export default "__VITE_ASSET__D6cf2nKB__"